import { LearningOpportunityUserStatus } from "@/server/backend-api/generated";

const admissionOfferAcceptedHeader = "Admission offer accepted";
const offerAcceptedText = "You have accepted the admission offer.";
export const AdmissionProcessStaticData = {
  admissionProgressHeader: {
    [LearningOpportunityUserStatus.LearnerApplied]: "Application sent",
    [LearningOpportunityUserStatus.OfferedToLearner]:
      "You have an admission offer",
    [LearningOpportunityUserStatus.LearnerAttending]:
      admissionOfferAcceptedHeader,
    [LearningOpportunityUserStatus.LearnerRejectedOffer]:
      "Admission offer declined",
    [LearningOpportunityUserStatus.AdmissionOfficerDeniedApplication]:
      "Application denied",
    [LearningOpportunityUserStatus.OfferToLearnerExpired]:
      "Application offer expired",
    // TODO: Map to same as "Accepted" for now.
    [LearningOpportunityUserStatus.LearnerCompleted]:
      admissionOfferAcceptedHeader,
    [LearningOpportunityUserStatus.LearnerDroppedOut]: "Unfinished",
    [LearningOpportunityUserStatus.LearnerFailed]: "Unfinished",
  },
  admissionProgressText: {
    [LearningOpportunityUserStatus.LearnerApplied]:
      "Thank you for applying to this learning opportunity! Rest assured - we're constantly reviewing all applications and will get back to you as soon as possible.",
    [LearningOpportunityUserStatus.OfferedToLearner]:
      "Great news! You have been offered a seat to this learning opportunity. Please accept or decline this offer by the latest ",
    [LearningOpportunityUserStatus.LearnerAttending]: offerAcceptedText,
    [LearningOpportunityUserStatus.LearnerRejectedOffer]:
      "You have declined the admission offer",
    [LearningOpportunityUserStatus.AdmissionOfficerDeniedApplication]:
      "Unfortunately, we cannot offer you a seat in this learning opportunity. Please see your email for a more detailed reply. Meanwhile, there are plenty of other learning opportunities to explore! You can browse them here.",
    [LearningOpportunityUserStatus.OfferToLearnerExpired]:
      "Your application offer has expired and is no longer available. There are still plenty of learning opportunities waiting for you, though. Browse them here.",
    [LearningOpportunityUserStatus.LearnerCompleted]: offerAcceptedText,
    [LearningOpportunityUserStatus.LearnerDroppedOut]:
      "You did not finish this learning opportunity.",
    [LearningOpportunityUserStatus.LearnerFailed]:
      "You did not finish this learning opportunity.",
  },
};
